import { QueryClient } from '@tanstack/react-query';

const DEFAULT_PAGE_SIZE = 20;

export const activityQueryKey = (propertyId: string, pageSize: number = DEFAULT_PAGE_SIZE) =>
  ['activity', propertyId, pageSize] as const;

export const refreshActivityForProperty = (queryClient: QueryClient, propertyId?: string) => {
  if (!propertyId) return;

  const queryKey = ['activity', propertyId] as const;
  queryClient.invalidateQueries({ queryKey }).catch(() => undefined);

  // Audit rows are read through a DynamoDB GSI, which can lag the write briefly.
  // Follow-up refetches keep newly-created RFQs from disappearing until focus/refetch.
  [1500, 4000].forEach((delay) => {
    window.setTimeout(() => {
      queryClient.refetchQueries({ queryKey, type: 'active' }).catch(() => undefined);
    }, delay);
  });
};
